exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1TYTfdpNmSsxeCPniZzz6Z .map .bottom .campaign-name{background-color:dycolor-internal(!name-background,@primary);color:dycolor-internal(!name-text,@theme-white)}._1TYTfdpNmSsxeCPniZzz6Z .map .bottom .nav-tabs .nav-item .nav-link{background-color:dycolor-internal(!tab-background,@theme-grey);color:dycolor-internal(!tab-text,@theme-black)}._1TYTfdpNmSsxeCPniZzz6Z .map .bottom .nav-tabs .nav-item .nav-link:hover{background-color:dycolor-internal(!tab-background-hover,@theme-light-grey)}._1TYTfdpNmSsxeCPniZzz6Z .map .bottom .nav-tabs .nav-item .nav-link.active{background-color:dycolor-internal(!tab-background-active,@theme-white)}\n", ""]);

// exports
exports.locals = {
	"root": "_1TYTfdpNmSsxeCPniZzz6Z"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/components/rabbit/campaign-wrapper/CampaignWrapper.scss
// module id = 899
// module chunks = 1